import { render, staticRenderFns } from "./_Contracts.vue?vue&type=template&id=bda9a63e&"
import script from "./_Contracts.vue?vue&type=script&lang=ts&"
export * from "./_Contracts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports